/**
 * PushTableSettingsButtonToTitleExtra Handler для HeaderPage
 *
 * Додає кнопку налаштувань відображення (колонки + фільтр) в titleExtra.
 */

import { TableSettingsButton } from '@/Core/UI/CrudResource/Components/TableSettings'

/**
 * Додає кнопку налаштувань відображення в titleExtra
 *
 * @param params - параметри з headerPageContext
 */
export const PushTableSettingsButtonToTitleExtra = ({ headerPageContext }: any) => {
    const crudContext = headerPageContext?.storages?.crudContext

    if (!crudContext || crudContext.contextType === 'detail') return

    headerPageContext.titleExtra ??= []

    headerPageContext.titleExtra.push(
        <TableSettingsButton key='crudresource-tablesettings-headerpage' crudContext={crudContext} />
    )
}
